/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement}
 */
const PauseIcon = ({ className }) => (
  <svg
    className={className}
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="44" height="44" fill="white" fillOpacity="0.9" />
    <path d="M16 30V14V30Z" fill="#002967" />
    <path d="M28 30V14V30Z" fill="#002967" />
    <path
      d="M16 30V14M28 30V14"
      stroke="#002967"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PauseIcon;
